/**
 * @generated SignedSource<<30488069bfa8e984f33fe9f1a2b43bfb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CharacterSelectSetDefaultMutation$variables = {
  id: string;
};
export type CharacterSelectSetDefaultMutation$data = {
  readonly setDefaultCharacter: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
        readonly id: string;
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly ok: boolean;
  };
};
export type CharacterSelectSetDefaultMutation = {
  response: CharacterSelectSetDefaultMutation$data;
  variables: CharacterSelectSetDefaultMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "characterId",
        "variableName": "id"
      }
    ],
    "concreteType": "SetDefaultCharacterPayload",
    "kind": "LinkedField",
    "name": "setDefaultCharacter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Character",
            "kind": "LinkedField",
            "name": "defaultCharacter",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audience",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CharacterSelectSetDefaultMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CharacterSelectSetDefaultMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "486937f350b0ec72e665fe719415815a",
    "id": null,
    "metadata": {},
    "name": "CharacterSelectSetDefaultMutation",
    "operationKind": "mutation",
    "text": "mutation CharacterSelectSetDefaultMutation(\n  $id: ID!\n) {\n  setDefaultCharacter(characterId: $id) {\n    ok\n    learner {\n      id\n      defaultCharacter {\n        id\n        audience\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1aebe4c1ce5c2467f0ef73fb43a1d47e";

export default node;
